import { Component, OnInit, Input } from '@angular/core';
import {TranslationService} from "../../services/translation.service";

@Component({
  selector: 'app-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.css']
})
export class TranslationComponent implements OnInit {

  @Input() phraseId:string;
  currentValue: string

  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    this.currentValue = this.translationService.translate(this.phraseId);
  }



}
